import styled from "styled-components";
import {
	DESKTOP_SM_BP,
	FONT_WT_LIGHT,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_WHITE,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	TABLET_M_BP,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	display: flex;
	background: ${COLOR_WHITE};
	margin-bottom: 27px;
	margin-right: 170px;
	padding: 20px 26.03px;
	align-items: center;
	.mentor-mobile {
		display: none;
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding: 20px 5px;
	}

	.mentor-image {
		@media only screen and (max-width: ${MOBILE_L_BP}px) {
			flex-basis: 45%;
			flex-grow: 0;
			flex-shrink: 0;
			padding-left: 5px;
		}
	}

	.mentor-info {
		padding: 0px 28px 0px 42px;

		@media only screen and (max-width: ${MOBILE_L_BP}px) {
			padding: 0px;
		}
		.mentor-dekstop {
			padding-top: 25px;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.mentor-dekstop {
			display: none;
		}
		.mentor-mobile {
			display: block;
			padding-top: 9px;
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		width: 90%;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		width: 100%;
	}
`;

export const Image = styled.div`
	height: 121px;
	img {
		height: 100%;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		height: 75px;
	}
`;

export const RatingImage = styled.div`
	text-align: center;
	margin-top: 12px;
	height: 16px;
	img {
		height: 100%;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		text-align: left;
		height: 9px;
		margin-top: 5px;
		img {
			height: 100%;
		}
	}
`;

export const About = styled.div`
	font-size: 16px;
	line-height: 1.5;
	font-weight: ${FONT_WT_LIGHT};
	color: ${COLOR_TEXT_PRIMARY_B2C};
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 14px;
	}
`;

export const Title = styled.div`
	font-size: 16px;
	line-height: 22px;
	font-weight: ${FONT_WT_MEDIUM};
	color: ${COLOR_TEXT_PRIMARY_B2C};
`;

export const SubTitle = styled.div`
	font-size: 16px;
	line-height: 22px;
	font-weight: ${FONT_WT_LIGHT};
	color: ${COLOR_TEXT_PRIMARY_B2C};
`;
